import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)`
  margin-top: 4%;
`;

export const RightBtnContainer = styled(Box)`
  display: flex;
  gap: 10px;
`;

export const FormContainer = styled(Box)`
  width: 45%;
  margin: 60px auto 0;
`;

export const ButtonsContainer = styled(Box)`
  width: 44%;
  display: flex;
  justify-content: space-between;
  margin: 20px auto 40px;
`;
